import API from 'api'
import { type Payload } from './types'

export const proposalCreateDimensioning = {
  post: async (payload: Payload) =>
    await API.post(`/proposal/create/dimensioning`, payload).then(
      ({ data }) => data,
    ),
}
